export const CHART = {
  SIZE: 250,
  MAX_SCORE: 10,
  LABEL_RADIUS_FACTOR: 1.3,
  LABEL_FONT: "bold 12px Arial",
};

export const WHEEL_OF_LIFE_LABEL = "Wheel of Life";
